<template>
  <div id="app">
    <router-view />

    <el-dialog
      :visible.sync="modal.alert.show"
      width="30%"
      center>
      <template slot="title">
        <img class="modal-logo-image" src="./assets/logo.png">
      </template>
      <span>{{modal.alert.message}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modal.alert.show = false">확인</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted () {
    this.$service.$on('alert-modal', (message) => {
      this.modal.alert.message = message
      this.modal.alert.show = true
    })
  },
  data () {
    return {
      modal: {
        alert: {
          show: false,
          message: ''
        }
      }
    }
  }
}
</script>

<style>
html, body {
  margin: 0; padding: 0;
  overflow-x: hidden;
  background-color: #ebebeb;
}
#app {
  font-family: 'Malgun Gothic', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.modal-logo-image {
  height: 26px;
}

.page-container {
  padding: 10px 16px;
  position: relative;
}
.dimmed-text {
  font-style:italic; color: #c1c1c1;
}
.alert-text {
  color: red;
  font-weight: bold;
}
</style>
